<template>
  <ValidationProvider
    #default="validationContext"
    :ref="refName"
    :name="name"
    :vid="name"
    :rules="rules"
    tag="div">
    <b-form-group :label="label">
      <b-form-textarea
        v-model="innerValue"
        v-bind="$attrs"
        :class="innerClass"
        :state="$getValidationState(validationContext)"
        rows="3">
      </b-form-textarea>
      <div v-if="isBtnDelete">
        <div class="pt-1">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-danger">
            delete
          </b-button>
        </div>
      </div>
      <b-form-invalid-feedback>
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, null],
      default: ''
    },
    name: {
      type: [String, null],
      default: ''
    },
    rules: {
      type: [String, Object],
      default: () => {}
    },
    label: {
      type: String,
      default: ''
    },
    innerClass: {
      type: String,
      default: ''
    },
    isBtnDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    refName () {
      return `validation-provider-${this.name}`
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
